import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import { GameService } from '../services/gameService';
import { IocContext } from 'power-di';

export class SpineAnim extends Container {
    public stopLoop = false;
    public spine: SpineGameObject;
    private spineContainer: SpineContainer;
    private gameService: GameService;

    constructor(
        scene: Scene,
        public key: string,
    ) {
        super(scene);
        this.gameService = IocContext.DefaultInstance.get(GameService);
        this.spineContainer = this.scene.add.spineContainer(0, 0);
        this.add(this.spineContainer);
        this.spine = this.scene.add.spine(0, 0, key);
        this.spineContainer.add(this.spine);
    }

    public invert() {
        this.spine.setScale(-1, 1);
    }

    public updateSlot(slotName: string) {
        const skel = this.spine.skeleton;
        const slot = skel.findSlot(slotName);
        const targetIndex = slot ? slot.data.index : -1;
        if (targetIndex === -1) return;

        // keep slot 0 (background) and the target visible – like your Pixi code
        for (let i = 0; i < skel.slots.length; i++) {
            const slot = skel.slots[i];

            // Option A: alpha toggle (quick, reversible)
            const visible = i === targetIndex || i === 0;
            slot.color.a = visible ? 1 : 0;
            // If you’re on the 4.1 two-color runtime, also keep darkColor alpha in sync:
            if ((slot as any).darkColor) (slot as any).darkColor.a = visible ? 1 : 0;

            // Option B (alternative): detach everything except the target/background
            // if (!visible) this.naipes.setAttachment(slot.data.name, null);
        }

        // Make sure transforms/render state are refreshed
        skel.updateWorldTransform();
        this.spine.update(0); // forces the game object to re-upload state this frame
    }

    public async loopAnimation(anim: string) {
        return new Promise((resolve) => {
            const { spine, spineContainer } = this;
            spine.on('complete', (a) => {
                if (this.stopLoop) {
                    spine.off('complete');
                    return resolve(0);
                } else {
                    spine.play(anim);
                }
            });
            spine.play(anim);
        });
    }

    public async startAnimation(anims: string[], delay?: number) {
        return new Promise((resolve) => {
            const { spine } = this;
            spine.on('complete', (a) => {
                anims.shift();
                if (!anims.length) {
                    spine.off('complete');
                    return resolve(0);
                } else {
                    spine.play(anims[0]);
                    this.emit('animsLeft', anims.length);
                    if (this.key !== 'dust') {
                        if (anims.length === 1) {
                            spine.off('complete');
                            return resolve(0);
                        }
                    }
                }
            });
            const playSpine = () => {
                spine.setVisible(false);
                spine.play(anims[0]);
                this.emit('animsLeft', anims.length);
                this.scene.time.addEvent({
                    callback: () => spine.setVisible(true),
                    delay: 20,
                });
            };
            if (delay) {
                this.scene.time.addEvent({
                    callback: () => playSpine(),
                    delay,
                });
            } else playSpine();
        });
    }
}
